import { render, staticRenderFns } from "./employees-list.vue?vue&type=template&id=518e44a2&"
import script from "./employees-list.vue.ts?vue&type=script&lang=ts&"
export * from "./employees-list.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports